import React from 'react';
import { registerIcons } from '@fluentui/style-utilities';
import { createSvgIcon } from './createSvgIcon';

export function createIconModule<T extends string>(
    iconName: T,
    svgComponent: (props: React.SVGAttributes<unknown>) => JSX.Element
): T {
    const IconComponent = createSvgIcon({
        Svg: svgComponent,
        displayName: iconName,
    });

    registerIcons({
        icons: {
            [iconName]: <IconComponent />,
        },
    });

    return iconName;
}
